import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const PipelineDealsModelSchema = z
  .object({
    id: z.string(),
    stage: z.string().nullish(),
    deal: z.string().nullish(),
    stage_date: z.string().nullish(),
    date_created: z.string().nullish(),
    sequence: z.number().nullish()
  })
  .strict()

export const PipelineDealsModelFields = makeFieldKeys(PipelineDealsModelSchema)

export type PipelineDealsModel = z.infer<typeof PipelineDealsModelSchema>

function validatePipelineDealsModel(data: unknown): PipelineDealsModel {
  try {
    return validateWithZodSchema(PipelineDealsModelSchema, data, 'pipeline deals model')
  } catch (error) {
    throw new Error(`Pipeline deals model validation failed: ${error}`)
  }
}
